


















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class UsersCustomerCenterIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#2F8C21' }) readonly color?: string;
}
